export default __webpack_public_path__ + "static/media/nayanz.dbec6319.mp4";